module.exports = __webpack_public_path__ + "img/vote-btn_txt2.b6f6b3fd.png";